import { z } from 'zod'

export const envSchema = z.object({
  BUILD_ENV: z
    .union([z.literal('local'), z.literal('staging'), z.literal('production')])
    .default('local'),
  INTL_ENV: z
    .union([z.literal('local'), z.literal('staging'), z.literal('production')])
    .default('local'),
  REACT_APP_STAGE: z
    .union([z.literal('local'), z.literal('staging'), z.literal('production')])
    .default('local'),
  REACT_APP_CONSOLE_DEBUG: z
    .string()
    .optional()
    .transform((val) => val === 'true'),
  REACT_APP_DEVTOOLS: z
    .string()
    .optional()
    .transform((val) => val === 'true'),
  REACT_APP_LOGGLY_KEY: z.string().optional(),
  REACT_APP_LOGGLY_ENV: z.string().optional(),
  REACT_APP_GRAPHQL_PUBLIC_URL: z.string().url(),
  REACT_APP_TRANSLATIONS_PUBLIC_URL: z.string().url(),
  REACT_APP_SERVICE_MANAGER_PUBLIC_URL: z.string().url(),
  REACT_APP_LAWYER_MANAGER_PUBLIC_URL: z.string().url(),
  REACT_APP_DOCUMENT_ANALYZER_PUBLIC_URL: z.string().url(),
  REACT_APP_DOWNLOAD_USER_DOCUMENTS_PUBLIC_URL: z.string().url()
})

export const env = envSchema.parse({
  BUILD_ENV: process.env.BUILD_ENV,
  INTL_ENV: process.env.INTL_ENV,
  REACT_APP_STAGE: process.env.REACT_APP_STAGE,
  REACT_APP_CONSOLE_DEBUG: process.env.REACT_APP_CONSOLE_DEBUG,
  REACT_APP_DEVTOOLS: process.env.REACT_APP_DEVTOOLS,
  REACT_APP_LOGGLY_KEY: process.env.REACT_APP_LOGGLY_KEY,
  REACT_APP_LOGGLY_ENV: process.env.REACT_APP_LOGGLY_ENV,
  REACT_APP_GRAPHQL_PUBLIC_URL: process.env.REACT_APP_GRAPHQL_PUBLIC_URL,
  REACT_APP_TRANSLATIONS_PUBLIC_URL: process.env.REACT_APP_TRANSLATIONS_PUBLIC_URL,
  REACT_APP_SERVICE_MANAGER_PUBLIC_URL: process.env.REACT_APP_SERVICE_MANAGER_PUBLIC_URL,
  REACT_APP_LAWYER_MANAGER_PUBLIC_URL: process.env.REACT_APP_LAWYER_MANAGER_PUBLIC_URL,
  REACT_APP_DOCUMENT_ANALYZER_PUBLIC_URL: process.env.REACT_APP_DOCUMENT_ANALYZER_PUBLIC_URL,
  REACT_APP_DOWNLOAD_USER_DOCUMENTS_PUBLIC_URL:
    process.env.REACT_APP_DOWNLOAD_USER_DOCUMENTS_PUBLIC_URL
})
